import styled from 'styled-components';

export const TabsContainer = styled.div`
  background: var(--color-interface-neutral-light);
  box-shadow: var(--elevation-medium);
  border-radius: var(--radius-8);
`;

export const TabsHeader = styled.ul`
  display: flex;
  margin: unset;
  padding: unset;
  list-style-type: none;
  border-top-right-radius: inherit;
  border-top-left-radius: inherit;
`;

export const TabHeaderItem = styled.li<{ active?: boolean }>`
  width: 100%;
  text-align: center;
  padding: var(--spacing-m);
  border-bottom: 2px solid;
  border-color: ${(p) =>
    p.active
      ? 'var(--color-interface-secondary-normal)'
      : 'var(--color-interface-layout-lighter)'};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-s);
  background: ${(p) =>
    p.active ? 'inherit' : 'var(--color-interface-layout-lightest)'};

  &:first-of-type {
    border-top-left-radius: inherit;
  }

  &:last-of-type {
    border-top-right-radius: inherit;
  }

  > p,
  > svg {
    color: var(--color-interface-secondary-normal);
  }
`;

export const TabsContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: var(--spacing-l);
  gap: var(--spacing-l);
`;
